module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-progress-circular', {
    attrs: {
      "size": 100,
      "width": 15,
      "rotate": 360,
      "value": _vm.value * 2,
      "color": "primary"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14cb4610","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Loader.vue
// module id = 734
// module chunks = 1